import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'

const CreateCareerFooter = ({ children }) => {
  return createPortal(
    <div className='fixed bottom-0 left-0 right-0 z-10 border-t border-gray-200 bg-white px-4 py-3 shadow-lg sm:px-6'>
      <div className='mx-auto max-w-6xl'>{children}</div>
    </div>,
    document.body
  )
}

CreateCareerFooter.propTypes = {
  children: PropTypes.node.isRequired
}

export default CreateCareerFooter
